class APIS {
	apis() {
		return {
			add: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/elevenlabs/agent/add'
			},
			all: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/elevenlabs/agent/all'
			},
			detail: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/elevenlabs/agent/detail'
			},
			update: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/elevenlabs/agent/update'
			},
			setActive: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/elevenlabs/agent/set-active'
			},
			delete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/ai/call/elevenlabs/agent/delete'
			}
		};
	}
}

export default new APIS();
